import { CellText, CheckboxContainer } from "assets/js/Styles";
import CustomCheckbox from "components/customs/checkbox";
import FormGenerator from "components/customs/form-generator/input";
import { ADD_ACTION } from "constants/actions";
import React, { useMemo } from "react";
import { Check } from "react-feather";
import { UncontrolledTooltip } from "reactstrap";
import styled from "styled-components";
import { getFormattedNumber } from "utility/helpers";

const StyledFormGenerator = styled(FormGenerator)`
  background: ${({ theme }) => theme.colors.white};
  height: unset;
  border-radius: 0;
  padding: 2px 10px !important;

  &[inputmode="numeric"] {
    height: 34px;
  }
`;

const AddProjectCourseColumns = ({
  handleBulkCheckboxOnChange,
  isDisabled,
  selectedCourses,
  data,
  handleCheckboxOnChange,
  action,
  handleSlotsOnChange,
}) => {
  const isAllChecked = useMemo(() => {
    return (
      (selectedCourses?.length === data?.length &&
        selectedCourses?.length > 0) ??
      false
    );
  }, [selectedCourses, data]);

  return [
    {
      name: "",
      selector: null,
      sortable: false,
      id: "highlight",
      width: "5px",
      cell: () => null,
    },
    {
      name: (
        <CheckboxContainer>
          <CustomCheckbox
            icon={<Check size={16} />}
            onChange={(evt) => handleBulkCheckboxOnChange(evt)}
            checked={isAllChecked}
            disabled={isDisabled}
          />
        </CheckboxContainer>
      ),
      selector: ({ id }) => id,
      sortable: false,
      width: "60px",
      cell: (record) => {
        const isChecked = selectedCourses?.some(
          (course) => course.id === record.id
        );

        return (
          <CheckboxContainer>
            <CustomCheckbox
              icon={<Check size={16} />}
              onChange={(evt) => handleCheckboxOnChange(record, evt)}
              checked={isChecked}
              disabled={isDisabled}
            />
          </CheckboxContainer>
        );
      },
    },
    {
      name: "Course",
      selector: ({ course }) => course,
      grow: 2,
      sortable: true,
      cell: ({ course }) => <CellText>{course}</CellText>,
    },
    {
      name: "Course Code",
      selector: null,
      sortable: false,
      cell: ({ courseCode }) => <CellText>{courseCode}</CellText>,
    },
    {
      name: "Cost / Slot",
      selector: ({ totalCost }) => totalCost,
      sortable: true,
      cell: ({ totalCost }) => (
        <CellText>{getFormattedNumber(totalCost)}</CellText>
      ),
    },
    {
      name: "Available Slots",
      selector: ({ availableSlots }) => availableSlots,
      sortable: true,
      cell: ({ availableSlots }) => (
        <CellText>{availableSlots?.toLocaleString("en-US")}</CellText>
      ),
    },
    {
      name: "Enter Slots",
      selector: (row) => row,
      sortable: true,
      cell: (record) => {
        const course = selectedCourses?.find((crs) => crs.id === record.id);
        const isChecked = !!course;

        const enteredSlots = isChecked ? Number(course.slots) : 0;

        const maxSlots =
          action === ADD_ACTION
            ? record.availableSlots
            : (record?.oldSlotsValue ?? 0) +
              Number(record?.availableSlots ?? 0);

        const exceeds = enteredSlots > maxSlots;

        return (
          <>
            <StyledFormGenerator
              id={`slot-input-${record.id}`}
              type="number"
              className={`${exceeds ? "form-control is-invalid" : ""}`}
              value={isChecked ? course?.slots : 0}
              disabled={!isChecked}
              onChange={(val) =>
                handleSlotsOnChange(record.id, val?.floatValue)
              }
            />

            {exceeds && (
              <UncontrolledTooltip
                placement="top"
                target={`slot-input-${record.id}`}
              >
                {"Entered slots cannot exceed available slots."}
              </UncontrolledTooltip>
            )}
          </>
        );
      },
    },
    {
      name: "Subtotal",
      selector: (row) => row,
      sortable: true,
      cell: ({ id, totalCost }) => {
        const course = selectedCourses?.find((crs) => crs.id === id);

        const subTotal =
          Number(totalCost) * Number(!course?.slots ? 0 : course?.slots);

        return <CellText>{subTotal && getFormattedNumber(subTotal)}</CellText>;
      },
    },
  ];
};

export default AddProjectCourseColumns;
